import { render } from "./PollResult.vue?vue&type=template&id=d6bab4f8"
import script from "./PollResult.vue?vue&type=script&lang=js"
export * from "./PollResult.vue?vue&type=script&lang=js"

import "./PollResult.vue?vue&type=style&index=0&id=d6bab4f8&lang=scss"

import exportComponent from "/builds/lahautesociete/projects/roche/depistage-diabete/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__